/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiSpacer } from '@elastic/eui'

import ApiConsoleMethod from './widgets/Method'
import ApiConsolePath from './widgets/Path'
import ApiConsoleBody from './widgets/Body'
import ApiConsoleOutput from './widgets/Output'

import type { ProxyRequestMethod } from './types'

type Props = {
  onRequest: (args: { method: ProxyRequestMethod; path: string; body: string }) => void
  isLoading: boolean
  response: Response | undefined
}

const ApiConsole: React.FunctionComponent<Props> = ({ onRequest, isLoading, response }) => {
  const [method, setMethod] = useState<ProxyRequestMethod>('GET')
  const [path, setPath] = useState<string>('')
  const [body, setBody] = useState<string>('')

  const isSubmitDisabled = !path.length

  return (
    <Fragment>
      <EuiFlexGroup>
        <EuiFlexItem grow={false}>
          <ApiConsoleMethod value={method} onChange={setMethod} />
        </EuiFlexItem>
        <EuiFlexItem grow={true}>
          <ApiConsolePath value={path} onChange={setPath} />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButton
            fill={true}
            disabled={isSubmitDisabled}
            onClick={() => {
              onRequest({ method, path, body })
            }}
          >
            <FormattedMessage id='apiConsole.submitButton' defaultMessage='Submit' />
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer />
      <ApiConsoleBody value={body} onChange={setBody} />

      <EuiHorizontalRule />

      <ApiConsoleOutput isLoading={isLoading} response={response} />
    </Fragment>
  )
}

export default ApiConsole
